import React = require('react');
import { Formik, FormikProps } from 'formik';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { UserSettings } from '../services/resources/UserSettings';
import _ = require('underscore');
import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../codegen/Localize';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { NotificationsSettingsProps } from './NotificationsSettings';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';

export interface DataAlertNotificationField {
    dataAlertNotificationEnabled: boolean;
}

function showButtons(formik: FormikProps<DataAlertNotificationField>, dataAlertNotificationEnabled: boolean) {
    if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.dataAlertNotificationEnabled, dataAlertNotificationEnabled)) {
        return false;
    }
    return true;
}

export function DataAlertNotification(props: NotificationsSettingsProps): JSX.Element {
    const [currentDataAlertNotificationEnabled, setCurrentDataAlertNotificationEnabled] = React.useState(false);

    async function handleSubmit(values: DataAlertNotificationField) {
        UserSettings.updateSuspendedDataAlertSetting(props.siteUser.id, values.dataAlertNotificationEnabled).then(() => {
            setCurrentDataAlertNotificationEnabled(values.dataAlertNotificationEnabled);
            ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
        }).catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
        });
    }

    React.useEffect(
      () => {
        UserSettings.getSuspendedDataAlertSetting(props.serverUser.id)
          .then((result: boolean) => {
            setCurrentDataAlertNotificationEnabled(result);
          })
          .catch(() => {});
      },
      // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    return (
        <Formik
            initialValues={{ dataAlertNotificationEnabled: currentDataAlertNotificationEnabled }}
            onSubmit={(values: DataAlertNotificationField) => handleSubmit(values)}
            enableReinitialize={true}
        >
            {
                (formik: FormikProps<DataAlertNotificationField>) => (
                    <form onSubmit={formik.handleSubmit}>
                        <table>
                            <tbody className={UserSettingsStyle.tbody}>
                                <tr data-tb-test-id="userSettings-data-alert-notification">
                                    <td className={UserSettingsStyle.labelText}>
                                        {Messages.dataAlertsTitle()}
                                </td>
                                    <td className={UserSettingsStyle.detailsValue}>
                                        {Messages.dataAlertSuspendedNotificationUserSettingDetail()}
                                </td>
                                </tr>
                                <tr>
                                    <td className={UserSettingsStyle.labelText} />
                                    <td className={UserSettingsStyle.detailsValue}>
                                        <FormikCheckbox
                                            containerStyle={{ marginLeft: 0 }}
                                            testId='Data-Alert-Notification-Enabled'
                                            name={'dataAlertNotificationEnabled'}
                                            disabled={props.userHasNoSiteId}
                                            label={Messages.dataAlertSuspendedNotificationUserSettingEnable()} />
                                    </td>
                                </tr>
                                {
                                    showButtons(formik, currentDataAlertNotificationEnabled) &&
                                    <InlineCancelAndSaveButtons
                                        testId={'data-alert-notification'}
                                        formik={formik}
                                    />
                                }
                            </tbody>
                        </table>
                    </form>
                )
            }
        </Formik>
    );
}